module.exports = __webpack_public_path__ + "static/media/care.2cf85fb9.svg";